import React from "react";

function LibrarySongTitle({ song }) {
    return <h4 className="library__song--title">{song.title}</h4>;
}

export default LibrarySongTitle;
